<template>
  <div class="inter-wrap" v-show="isShowCheckIn">
    <div class="inter-mask"></div>
    <div class="inter-modal">
      <div class="inter-info">
        <div class="inter-head">
          <div class="inter-tit">签到</div>
          <div><img @click="onSetCheckInVisible(false)" :src="closeImg" alt="" /></div>
        </div>
        <check-in
          :check-in-sdk="checkInSdk"
          @to-show="onSetCheckInVisible(true)"
          @to-hide="onSetCheckInVisible(false)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import zModal from '@/components/ZModal'
import { CheckIn as CheckInSDK } from '@polyv/interactions-receive-sdk'
import CheckIn from '@polyv/interactions-receive-sdk-ui-default/lib/PcCheckIn'
import closeImg from '@/assets/icons/close.png'
export default {
  name: '',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      isImage: false,
      closeImg,
      checkInSdk: null, // 签到SDK实例
      isShowCheckIn: false, // 是否显示签到
    }
  },
  components: {
    zModal,
    CheckIn,
  },
  async created() {
    this.initPolyIr()
  },
  beforeDestroy() {
    this.checkInSdk.destroy()
  },
  methods: {
    initPolyIr() {
      this.checkInSdk = new CheckInSDK()
      // this.checkInCore.on('show-result', ({ checkInId }) => {
      //   this.checkInVisible = true
      //   this.checkInResultId = checkInId
      // })
    },
    onSetCheckInVisible(visible) {
      this.isShowCheckIn = visible
    },
  },
}
</script>
<style lang="less" scoped>
.inter-wrap {
  z-index: 999;
  width: 100%;
}
.inter-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  filter: alpha(opacity=50);
}
.inter-info {
  width: 600px;
  background-color: #fff;
  position: absolute;
  top: 100px;
  margin: 0 auto;
  z-index: 99999;
  border-radius: 10px;
}
.inter-modal {
  display: flex;
  align-content: center;
  justify-content: center;
}
.inter-head {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.inter-head img {
  width: 12px;
  height: 12px;
}
.inter-tit {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}
</style>
